import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bridge-monitoring-charts"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.charts.packets')))]), _vm.isLoadingPackets ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.packetsChartData,
      "options": _vm.chartOptions
    }
  })], 1)], 1), _c(VRow, {
    staticClass: "mt-4"
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.charts.states')))]), _vm.isLoadingStates ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.statesChartData,
      "options": _vm.stateChartOptions
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };